export const NUMERIC_REGEXP = /[-]?[\d]*[.]?[\d]*/;
export const NUMERIC_WITH_PERCENTAGE_REGEXP = /[-]?[\d]*[.]?[\d]*[%]?/;
export function numericInputFilter(v = '') {
  return v.replace(/[^0-9.-]/g, '')
    .replace(/(?!^)-/g, '')
    .replace(/(\..*?)\..*/g, '$1');
}
